import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuthContext } from '../context/auth.context';

interface IInactivityLogout {
  children: React.ReactNode;
}

const InactivityLogout: React.FC<IInactivityLogout> = ({ children }) => {
  const { pathname } = useLocation();
  const { onLogout } = useAuthContext();
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    const resetTimer = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        onLogout();
      }, 30 * 60 * 1000);
    };

    window.addEventListener('mousemove', resetTimer);
    window.addEventListener('keypress', resetTimer);
    resetTimer();

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      window.removeEventListener('mousemove', resetTimer);
      window.removeEventListener('keypress', resetTimer);
    };
  }, [pathname]);

  return <>{children}</>;
};

export default InactivityLogout;
